(function () {
  'use strict';

  function cardStep(strip) {
    var card = strip.querySelector('.thh-reviews__card');
    if (!card) return strip.clientWidth;
    var styles = getComputedStyle(strip);
    var gap = parseInt(styles.columnGap || styles.gap || '0', 10) || 0;
    return card.getBoundingClientRect().width + gap;
  }

  function buildDots(section) {
    var strip = section.querySelector('[data-thh-rev-strip]');
    var dots = section.querySelector('[data-thh-rev-dots]');
    if (!strip || !dots) return;
    var cards = strip.querySelectorAll('.thh-reviews__card');
    dots.innerHTML = '';
    for (var i = 0; i < cards.length; i++) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'thh-reviews__dot' + (i === 0 ? ' is-active' : '');
      b.setAttribute('data-thh-rev-dot', String(i));
      b.setAttribute('aria-label', 'Go to review ' + (i + 1));
      dots.appendChild(b);
    }
  }

  function updateActive(section) {
    var strip = section.querySelector('[data-thh-rev-strip]');
    var dots = section.querySelectorAll('[data-thh-rev-dot]');
    if (!strip || !dots.length) return;
    var idx = Math.round(strip.scrollLeft / cardStep(strip));
    for (var i = 0; i < dots.length; i++) {
      dots[i].classList.toggle('is-active', i === idx);
    }
  }

  function init() {
    document.querySelectorAll('[data-thh-reviews]').forEach(function (section) {
      var strip = section.querySelector('[data-thh-rev-strip]');
      if (!strip || strip.__thhRevInit) return;
      strip.__thhRevInit = true;
      buildDots(section);
      strip.addEventListener('scroll', function () { updateActive(section); }, { passive: true });
    });
  }

  document.addEventListener('click', function (e) {
    var section = e.target.closest('[data-thh-reviews]');
    if (!section) return;
    var strip = section.querySelector('[data-thh-rev-strip]');
    if (!strip) return;
    if (e.target.closest('[data-thh-rev-next]')) {
      strip.scrollBy({ left: cardStep(strip), behavior: 'smooth' });
    } else if (e.target.closest('[data-thh-rev-prev]')) {
      strip.scrollBy({ left: -cardStep(strip), behavior: 'smooth' });
    } else {
      var dot = e.target.closest('[data-thh-rev-dot]');
      if (dot) {
        var i = parseInt(dot.getAttribute('data-thh-rev-dot'), 10) || 0;
        strip.scrollTo({ left: i * cardStep(strip), behavior: 'smooth' });
      }
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('thh:synced', init);
})();
